import React, { useState } from "react";
import Use_Reference_Material_table from "./use_Reference_Material_table/Use_Reference_Material_table";
import Use_Reference_Material_Form from "./use_Reference_Material_Form/Use_Reference_Material_Form";

function Use_Reference_Material() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Use_Reference_Material_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Use_Reference_Material_table/>
        </div>
      )}
    </>
  );
}

export default Use_Reference_Material;
